import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import {TXHR} from '../../../../../assets/constants/constansts.type';
import * as css from './WhatsAppEditorFooterActions.css';

interface WhatsAppEditorFooterActionsProps {
    segmentedValue: string;
    onModeSwitch: (mode: string) => void;
    hasChanged: boolean;
    save: {
        onSave?: () => void;
        disabled?: boolean;
        xhr?: TXHR;
        text?: string;
    };
}

function WhatsAppEditorFooterActions({
    segmentedValue,
    onModeSwitch,
    hasChanged,
    save
}: WhatsAppEditorFooterActionsProps) {
    const {t} = useTranslation('branding');
    const isTemplateMode = segmentedValue === 'template';
    const nextMode = isTemplateMode ? 'free' : 'template';

    return (
        <css.actionsRow>
            {isTemplateMode && (
                <css.actionButton isFullWidth={true}>
                    <Button
                        variant="primary"
                        size="category"
                        onClick={() => onModeSwitch(nextMode)}
                        title={t('whatsapp:backToFreeEditing')}
                        data-cy="whatsapp-editor-mode-switch-btn"
                    >
                        {t('whatsapp:backToFreeEditing')}
                    </Button>
                </css.actionButton>
            )}
            {save.onSave && (
                <css.actionButton isFullWidth={isTemplateMode}>
                    <Button
                        variant="brand"
                        disabled={!hasChanged || save.disabled}
                        onClick={save.onSave}
                        title="Save"
                        size="category"
                        data-cy="whatsapp-editor-save-btn"
                        xhrState={save.xhr}
                    >
                        {save.text ?? t('save')}
                    </Button>
                </css.actionButton>
            )}
        </css.actionsRow>
    );
}

export default WhatsAppEditorFooterActions;
